/**
 * @fileoverview History data source and type definitions.
 */

import { HistorySchema, type History } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createCreatedAtField, createIdField, createJsonField, createNumberField, createStringField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { History };

export const historyDataSource = createBaseDataSource<History>({
  endpoint: 'history',
  searchField: 'note_id',
  schema: HistorySchema,
  fields: [
    createIdField(),
    createStringField('note_id', 'Note ID', FIELD_WIDTHS.SMALL),
    createNumberField('version_number', 'Version', FIELD_WIDTHS.SMALL),
    createStringField('title', 'Title', FIELD_TYPE_WIDTHS.NAME),
    createStringField('content', 'Content', FIELD_WIDTHS.XLARGE),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.MEDIUM),
    createCreatedAtField(),
  ],
});

export const historyCache = getCache('history');
